import packageJson from "./../../package.json";
// import firebaseConfig from "./firebase";

if (process.env.NODE_ENV === "production") {
  const variables = [
    "REACT_APP_APOLLO_URI",
    // "REACT_APP_SENTRY_DSN"
  ];
  for (let variable of variables) {
    if (!process.env[variable]) {
      throw new Error(`Kindly Provide Variable ${variable} In Env`);
    }
  }
}

interface Config {
  env: "production" | "staging" | "sandbox" | "test" | "development";
  appDomain: "Visal" | "KEK" | "Comfy";
  name: string;
  brokerId: string;
  asset: {
    uri: string;
    placeItUri: string;
  };
  apollo: {
    uri: string;
    placeItUri: string;
    kekUri: string;
    name: string;
    version: string;
  };
  sentry: {
    dsn: string;
    env: "production" | "staging" | "sandbox" | "test";
  };
  rollbar: {
    accessToken: string;
    env: "production" | "staging" | "sandbox" | "test";
  };
  cookies: {
    domain: string;
    secure: boolean;
    sameSite: "strict" | "Strict" | "lax" | "Lax" | "none" | "None";
  };
  constants: {
    page: number;
    pageSize: number;
    dateFormat: string;
  };
  pusher: {
    key: string;
    cluster: string;
    channel: string;
    event: string;
    channels: {
      kava: string;
      placeIt: string;
    };
    //     export const PUSHER_KEY = "6732a1bd9862dfe49492";
    // export const PUSHER_CLUSTER = "eu";
    // export const CHANNEL = "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0";
    // export const EVENT = "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0-event";
  };
}

const config: Config = {
  env: (process.env.NODE_ENV as any) ?? "development",
  name: packageJson.name,
  appDomain: (process.env.REACT_APP_DOMAIN as any) ?? "Visal",
  brokerId: process.env.REACT_APP_BROKER_ID ?? "1",
  asset: {
    uri: process.env.REACT_APP_ASSET_URI ?? "",
    placeItUri: process.env.REACT_APP_PLACE_IT_ASSET_URI ?? "",
  },
  apollo: {
    placeItUri: process.env.REACT_APP_PLACE_IT_URI ?? "",
    uri: process.env.REACT_APP_APOLLO_URI ?? "",
    kekUri: process.env.REACT_APP_APOLLO_URI ?? "",
    name: packageJson.name,
    version: packageJson.version,
  },
  sentry: {
    dsn:
      process.env.REACT_APP_SENTRY_DSN ??
      "https://examplePublicKey@o0.ingest.sentry.io/0",
    env: process.env.REACT_APP_SENTRY_ENV as any,
  },
  rollbar: {
    accessToken:
      process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN ??
      "845a5a5ed2d24502ab2082397b3297fc",
    env: (process.env.REACT_APP_ROLLBAR_ENV as any) ?? "development",
  },
  cookies: {
    domain: window.location.hostname?.split(".")?.slice(1)?.join("."),
    secure: true,
    sameSite: "strict",
  },
  constants: {
    page: 1,
    pageSize: 10,
    dateFormat: "",
  },
  pusher: {
    channel: process.env.REACT_APP_PUSHER_CHANNEL ?? "",
    cluster: process.env.REACT_APP_PUSHER_CLUSTER ?? "",
    key: process.env.REACT_APP_PUSHER_KEY ?? "",
    event: process.env.REACT_APP_PUSHER_EVENT ?? "",
    channels: {
      kava: process.env.REACT_APP_PUSHER_CHANNEL_KAVA ?? "",
      placeIt: process.env.REACT_APP_PUSHER_CHANNEL_PLACE_IT ?? "",
    },
  },
};

export default config;
